<section class="section discover">
  <div class="section-content">
    <div class="container-xl">
      <div
        class="content"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-between center"
        fxLayoutGap="30px"
      >
        <div class="text">
          {{ text }}
        </div>
        <div class="action" fxFlexAlign="end" fxFlexAlign.lt-md="center">
          <a class="btn btn-rounded btn-action" [href]="linkUrl">
            <span>{{ linkText }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
